module.exports = __webpack_public_path__ + "static/media/melissa7.d353a6ba.jpg";